// extracted by mini-css-extract-plugin
export default {"container":"iFN0Vc0MuNvC6kJGcTFC","updateInfoContainer":"D5RokV84MtcPzy9N9u0g","icon":"FCiZJveGnEKu_ZbmTIzt","active":"h3168pVvgEOwDU9ZV3tP"};